module.exports = __webpack_public_path__ + "img/isometric-squares.4f210f2f.svg";